import { createClient } from '@supabase/supabase-js'

// Workaround for Supabase 2.x lock deadlock — see:
// https://github.com/supabase/supabase-js/issues/1594
// https://github.com/supabase/supabase-js/issues/2013
// The default navigator.locks-based lock can hang indefinitely if a
// previous tab/session didn't cleanly release the lock. Disabling
// cross-tab coordination is safe for this app (single-user sessions).
const noOpLock = async (_name, _acquireTimeout, fn) => fn()

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    lock: noOpLock,
  },
})

export async function getAuthHeaders(extra = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  return {
    ...extra,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}